var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 7C0.523438 7 0.25 6.72656 0.25 6.375V1.375C0.25 1.0625 0.523438 0.75 0.875 0.75C1.1875 0.75 1.5 1.0625 1.5 1.375V5.00781C3.02344 2.46875 5.79688 0.75 9 0.75C13.8047 0.75 17.75 4.69531 17.75 9.5C17.75 14.3438 13.8047 18.25 9 18.25C5.875 18.25 3.14062 16.6484 1.57812 14.1875C1.30469 13.7578 1.61719 13.25 2.125 13.25C2.35938 13.25 2.55469 13.4062 2.67188 13.6016C4 15.6328 6.34375 17 9 17C13.1406 17 16.5 13.6406 16.5 9.5C16.5 5.35938 13.1406 2 9 2C6.1875 2 3.76562 3.52344 2.47656 5.75H5.875C6.1875 5.75 6.5 6.0625 6.5 6.375C6.5 6.72656 6.1875 7 5.875 7H0.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.6fce188ba561c7be88b8eb5acd771b25.svg";
export { ForwardRef as ReactComponent };